"use strict";
// for comparable to live.semios.com/admin/roles
// only for super-admins
// get roles and role type
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.null();
exports.path = '/admin-get-roles';
//# sourceMappingURL=index.js.map